import { flow } from 'fp-ts/lib/function';

export const isBetweenInclusive =
  (minimum: number, maximum: number) =>
  (x: number): boolean =>
    x >= minimum && x <= maximum;

export const isBetweenLeftInclusive =
  (minimum: number, maximum: number) =>
  (x: number): boolean =>
    x >= minimum && x < maximum;

export function between(
  minimum: number,
  maximum: number,
): (x: number) => number {
  return flow(max(minimum), min(maximum));
}

export function min(...x: number[]): (y: number) => number {
  return (y) => Math.min(...x, y);
}

export function max(...x: number[]): (y: number) => number {
  return (y) => Math.max(...x, y);
}

export function multiply(x: number): (y: number) => number {
  return (y) => x * y;
}

export const divide =
  (divisor: number) =>
  (dividend: number): number =>
    dividend / divisor;
